// src/app/widget/pages/tour/tour-service-card/tour-service-card.component.ts
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { WIDGET_CONSTANTS } from '../../../../constants/widget-constants';
import { TRANSLATION_TEMPLATES } from '../../../../constants/translation-templates-constants';
import { TourEligibleServiceDao } from '../../../../db-models/tour-dao';
import { CustomBookingMessageTemplate } from '../../../../db-models/widget-conf-dao';
import { HelperService } from '../../../../services/helper.service';
import { TranslationPipe } from '../../../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-tour-service-card',
  templateUrl: './tour-service-card.component.html',
  styleUrls: ['./tour-service-card.component.scss'],
  imports: [TranslateModule, FaIconComponent, TranslationPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourServiceCardComponent {
  private helperService = inject(HelperService);

  readonly service = input.required<TourEligibleServiceDao>();
  readonly isSelected = input.required<boolean>();
  readonly isDisabled = input<boolean>(false);
  readonly widgetTemplates = input<CustomBookingMessageTemplate[]>([]);
  readonly lang = input<string>('en');

  readonly toggle = output<void>();
  readonly viewAbsences = output<TourEligibleServiceDao>();

  readonly templateContent = TRANSLATION_TEMPLATES;

  readonly hasUpcomingAbsences = computed(
    () => (this.service().upcoming_absences?.length ?? 0) > 0,
  );

  readonly upcomingAbsencesTemplate = computed(() =>
    this.helperService.findTemplate(
      this.widgetTemplates(),
      WIDGET_CONSTANTS.WIDGET_LABELS.WIDGET_TOUR_UPCOMING_ABSENCES_LABEL,
    ),
  );

  onClick(): void {
    if (this.isDisabled()) return;
    this.toggle.emit();
  }

  onBadgeClick(event: MouseEvent | KeyboardEvent): void {
    event.stopPropagation();
    if ('preventDefault' in event) event.preventDefault();
    this.viewAbsences.emit(this.service());
  }

  durationMinutes(): number {
    return Math.round((Number(this.service().duration) || 0) * 60);
  }
}
